import { queryOptions } from '@tanstack/react-query';

import { apiLookupFetch } from '..';
import { Country, Currency, GetCountriesParams, LocationList, Region } from './types';

export const LOOKUP_QUERY_KEYS = {
  currencies: 'currencies',
  countries: 'countries',
  regions: 'regions',
};

export const _getCurrencies = () =>
  queryOptions({
    queryKey: [LOOKUP_QUERY_KEYS.currencies],
    queryFn: () => apiLookupFetch<Currency[]>('/currencies'),
  });

export const _getCountries = (
  params: GetCountriesParams = { list: LocationList.PASSPORT, includeRegions: false },
) =>
  queryOptions({
    queryKey: [LOOKUP_QUERY_KEYS.countries, params.list, params.includeRegions],
    queryFn: () => apiLookupFetch<Country[]>('/countries', { params }),
  });

export const _getCountry = (
  countryCode: string,
  params: Pick<GetCountriesParams, 'list'> = { list: LocationList.PASSPORT },
) =>
  queryOptions({
    queryKey: [LOOKUP_QUERY_KEYS.countries, countryCode, params.list],
    queryFn: () => apiLookupFetch<Country>(`/countries/${countryCode}`, { params }),
    enabled: !!countryCode,
  });

export const _getRegions = (
  countryCode: string,
  params: Pick<GetCountriesParams, 'list'> = { list: LocationList.PASSPORT },
) =>
  queryOptions({
    queryKey: [LOOKUP_QUERY_KEYS.regions, countryCode, params.list],
    queryFn: () => apiLookupFetch<Region[]>(`/countries/${countryCode}/regions`, { params }),
    enabled: !!countryCode,
  });
